import { Map as MapLibreMap } from 'maplibre-gl';
import { useEffect, useRef, useState } from 'react';
import { configureMapLibreWorker } from '../../../../../shared/features/maps/adapters/configure-maplibre-worker';
import { basemapStyleUrl } from '../../../../../shared/features/maps/policies/basemap';
import { CORRIDOR_CENTER, CORRIDOR_ZOOM } from '../../../../../shared/features/maps/policies/map-framing';
import { useColorMode } from '../../../../../shared/features/theme/components/ColorModeProvider';

/** A bare basemap for drawing one flagged area on; returns the map once it has loaded, for terra-draw to attach to. */
export function useFlaggedAreaMap(tileKey: string | null) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [map, setMap] = useState<MapLibreMap | null>(null);
  const { mode } = useColorMode();

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !tileKey) return;
    configureMapLibreWorker();
    const created = new MapLibreMap({ container, style: basemapStyleUrl(mode, tileKey), center: CORRIDOR_CENTER, zoom: CORRIDOR_ZOOM });
    created.on('load', () => setMap(created));
    return () => {
      setMap(null);
      created.remove();
    };
  }, [tileKey, mode]);

  return { containerRef, map };
}
